import React from 'react'
import PropTypes from 'prop-types'
import Chip from '@material-ui/core/Chip'

function ChipSelectRender({
  chipsClassName, chipClassName, items, selectedValue,
}) {
  return (
    <div className={chipsClassName}>
      {items.filter((p) => p.id !== '' && selectedValue.includes(p.id)).map((item) => (
        <Chip key={item.id} label={item.name} className={chipClassName} />
      ))}
    </div>
  )
}

ChipSelectRender.defaultProps = {
  chipClassName: '',
  chipsClassName: '',
}

ChipSelectRender.propTypes = {
  chipClassName: PropTypes.string,
  chipsClassName: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  ).isRequired,
  selectedValue: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  ).isRequired,
}

export default ChipSelectRender
